var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 6.4445C4.66675 5.97295 4.85407 5.52071 5.18751 5.18727C5.52095 4.85383 5.97319 4.6665 6.44475 4.6665H12.2221C12.4556 4.6665 12.6868 4.71249 12.9025 4.80185C13.1182 4.8912 13.3142 5.02217 13.4793 5.18727C13.6444 5.35237 13.7754 5.54838 13.8647 5.76409C13.9541 5.97981 14.0001 6.21101 14.0001 6.4445V12.2218C14.0001 12.4553 13.9541 12.6865 13.8647 12.9022C13.7754 13.118 13.6444 13.314 13.4793 13.4791C13.3142 13.6442 13.1182 13.7751 12.9025 13.8645C12.6868 13.9538 12.4556 13.9998 12.2221 13.9998H6.44475C6.21126 13.9998 5.98005 13.9538 5.76434 13.8645C5.54862 13.7751 5.35261 13.6442 5.18751 13.4791C5.02241 13.314 4.89144 13.118 4.80209 12.9022C4.71274 12.6865 4.66675 12.4553 4.66675 12.2218V6.4445Z",
    stroke: "#211D25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667",
    stroke: "#211D25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d435eabc2acfbf545b1577dcd2085a51.svg";
export { ForwardRef as ReactComponent };